<div class="new-password-container">
  <div class="new-password-container-card">
    <a routerLink="/">
      <img class="new-password-container-card--logo" src="assets\logos\logo-projeto.svg">
    </a>

    <form class="new-password-container-card--form" #form="ngForm" (ngSubmit)="handleNewPassword()">
      <div class="new-password-container-card--form-input">
        <label for="newPassword">Senha:</label>
        <div class="new-password-container-card--form-input-show-password">
          <input [type]="hide ? 'password' : 'text'" id="newPassword" name="newPassword" [(ngModel)]="newPasswordForm.newPassword" #newPassword="ngModel" class="form-control" placeholder="Digite a sua nova senha" pattern=".{6,}" minlength="6" required>
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" type="button">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </div>
        <div class="new-password-container-card--form-input-error" *ngIf="newPassword.invalid && (newPassword.dirty || newPassword.touched)">
          <mat-error *ngIf="newPassword.errors?.['required']">Este campo é obrigatório</mat-error>
          <mat-error *ngIf="newPassword.errors?.['minlength']">Este campo deve ter pelo menos 6 digitos</mat-error>
        </div>
      </div>

      <div class="new-password-container-card--form-input">
        <label for="confirmPassword">Nova senha:</label>
        <div class="new-password-container-card--form-input-show-password">
          <input [type]="hide ? 'password' : 'text'" id="confirmPassword" name="confirmPassword" [(ngModel)]="newPasswordForm.confirmPassword" #confirmPassword="ngModel" class="form-control" placeholder="Confirme a sua nova senha" pattern=".{6,}" minlength="6" required>
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" type="button">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </div>
        <div class="new-password-container-card--form-input-error" *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)">
          <mat-error *ngIf="confirmPassword.errors?.['required']">Este campo é obrigatório</mat-error>
          <mat-error *ngIf="confirmPassword.errors?.['minlength']">Este campo deve ter pelo menos 6 digitos</mat-error>
        </div>
      </div>
      <button class="btn btn-primary new-password-container-card--form-submit" type="submit" [disabled]="form.invalid">Alterar</button>
    </form>
  </div>
</div>
  
  
  
